(function(){
  // Initialize Swiper

  var items = document.querySelectorAll('.product-exclusive-coupons-swiper:not([initialized])')

  items.forEach(function(item) {
    var variantId = item.getAttribute('data-variant')
    
    var swiper = new Swiper('.product-exclusive-coupons-swiper-' + variantId, {
      effect: 'cards',
      grabCursor: true,
      direction: 'vertical',
      slidesPerView: 'auto',
      loop: true,
      pagination: {
        el: '.swiper-pagination-' + variantId,
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next-' + variantId,
        prevEl: '.swiper-button-prev-' + variantId,
      },
      cardsEffect: {
        perSlideOffset: 10, // Space between cards in px
        perSlideRotate: 0, // Rotation of cards in degrees
        rotate: 0,
      },
    });

    // console.log(item, variantId)
  })

  document.addEventListener('variant:change', function (evt) {
    var allItems = document.querySelectorAll('.product-exclusive-coupons-swiper')
    var activeItem = document.querySelector('.product-exclusive-coupons-swiper-'+evt.detail.variant.id)

    allItems.forEach(function (item) {
      item.style.display = 'none'
    })

    if (activeItem) {
      activeItem.style.display = 'block'

      var variantId = evt.detail.variant.id
    
      var swiper = new Swiper('.product-exclusive-coupons-swiper-' + variantId, {
        effect: 'cards',
        grabCursor: true,
        direction: 'vertical',
        slidesPerView: 'auto',
        loop: true,
        pagination: {
          el: '.swiper-pagination-' + variantId,
          clickable: true,
        },
        navigation: {
          nextEl: '.swiper-button-next-' + variantId,
          prevEl: '.swiper-button-prev-' + variantId,
        },
        cardsEffect: {
          perSlideOffset: 10, // Space between cards in px
          perSlideRotate: 0, // Rotation of cards in degrees
          rotate: 0,
        },
      });
    }
  });
})()